// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets//bg4.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
}
.SignUp_contact-flex-container__S3fTq {
  padding-top: 3px;
  padding-bottom: 10px;
  display: flex;
  max-width: 100%;
  padding: 1rem 2rem;
  justify-content: space-around;
  align-items: center;
  gap: 1%;
  background-repeat: repeat;
  background-size: cover;
  flex-direction: row;
  height: auto;
  background-position: center;
  margin-top: 2rem;
}

.SignUp_top-icon__LgsDq {
  background-position: 25% 75%;
  position: absolute;
  z-index: 1;
  left: 38%;
  max-width: 7rem;
  padding-top: 2%;
}

.SignUp_large-heading-1__2AZD\\+ {
  font-weight: 900;
}

.SignUp_top-arrow__eNB7o {
  max-width: 7rem;
  background-position: 25% 75%;
  position: absolute;
  z-index: 1;
  margin-left: 2%;
}
.SignUp_contact-left-image__5XC31 img {
  max-width: 11rem;
  height: auto;
  font-family: "Poppins", sans-serif;
  margin-top: 20%;
  margin-bottom: 1rem;
}
.SignUp_contact-form__XCoFC {
  margin-top: 40px;
  font-family: "Poppins", sans-serif;
}
.SignUp_checkbox__gGynt {
  grid-column: 1/-1;
}

.SignUp_special_button__axfZu {
  position: absolute;
  left: 100%;
}

.SignUp_bottom_image__IsKY5 {
  position: fixed;
  height: 8rem;
  bottom: 0;

  /* @media screen and (max-width: 1800px) and (min-width: 1036px) {
    bottom: none;
  } */
}



.SignUp_sticky-button__ReuKQ.SignUp_enabled__sAyUn {
  opacity: 1;
  cursor: pointer;
  background-color: black;
}

.SignUp_input-field__n9LuY:focus {
  color: black;
}

.SignUp_input-type__buu\\+c {
  font-size: large;
  word-spacing: 3px;
  font-family: "Poppins", sans-serif;
}

/* .loader {
  border: 16px solid #f3f3f3;
  border-top: 16px solid rgb(71, 122, 246);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  margin: 25px;
  animation: spin 5s linear infinite; */

/* @keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
} */
.SignUp_text-center__CUJeG {
  font-family: "Poppins", sans-serif;
}

.SignUp_input-field__n9LuY {
  width: 100%;
  padding: 11px 18px;
  font-size: 14px;
  position: relative;
  border: none;
  background-color: inherit;
  /* box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; */
  border-radius: 9px;
  border: 1px solid grey;
  cursor: pointer;
  font-family: "Poppins", sans-serif;
}
.SignUp_input-field__n9LuY:focus {
  border-bottom-color: black;
  font-family: "Poppins", sans-serif;
}
.SignUp_input-otp__yHHiJ:focus {
  border-bottom-color: black;
}
.SignUp_label__fsVsI {
  display: block;
  margin-bottom: 0.5rem;
}
select {
  color: black;
}
option {
  color: black;
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
}
.SignUp_input-field__n9LuY::placeholder .SignUp_input-field__n9LuY,
.SignUp_contact-form__XCoFC,
.SignUp_contact-form__XCoFC p {
  color: black;
}
.SignUp_input-field__n9LuY::placeholder {
  color: grey;
}
.SignUp_form-control__vATZ0 {
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, minmax(3, 1fr));
  gap: 1rem;
  margin-top: 3rem;
}
.SignUp_textarea__Jvseu {
  position: absolute;
  grid-column: 1/-1;
  height: 100%;
  background-color: inherit;
  border: none;
  color: black;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 50px;
  padding: 8px;
  cursor: pointer;
}
.SignUp_custom-shape-divider-bottom-1666093673__FPYrm {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
}

.SignUp_custom-shape-divider-bottom-1666093673__FPYrm svg {
  position: relative;
  display: block;
  width: calc(100% + 1.3px);
  height: 150px;
}

.SignUp_custom-shape-divider-bottom-1666093673__FPYrm .SignUp_shape-fill__f107c {
  fill: #ffffff;
}
input[type="submit"] {
  color: white;
  background-color: #477AF6;
  font-size: 14px;
  padding: 11px;
  letter-spacing: 0.09em;
  border: none;
  border-radius: 2px;
  font-weight: 500;
}

input[type="submit"]:hover {
  cursor: pointer;

  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.SignUp_phone-input__O1kKN {
  font-size: 12px;
  border: 1px solid #5e6ff9;
  border-radius: 28px;
  width: 100%;
  outline: none;
}
.SignUp_react-tel-input__r5Yzl .SignUp_form-control__vATZ0 {
  width: inherit;
  background-color: inherit;
  font-size: 14px;
  padding: 14px 14px 10px 60px;
  color: black;
  border: none;
  border-radius: 9px;
  width: 100%;
  border: 1px solid grey;
}
.SignUp_react-tel-input__r5Yzl .SignUp_form-control__vATZ0:focus {
  background-color: inherit;
  box-shadow: none;
}
.SignUp_contact-form__XCoFC #SignUp_dropdown__VunzG {
  padding: 14px;
  margin-top: 2%;
}
/* .modal-pointer:focus-visible{
  background-color: rgb(71, 122, 246);
}  */

.SignUp_input-otp__yHHiJ :hover::after {
  background-color: rgb(71, 122, 246);
}

.SignUp_modal-body__iJ9IN > h2 > div {
  justify-content: center;
}
.SignUp_btn-link__ivTUi:focus {
  background-color: none !important;
}
#SignUp_get-in-touch__6JsmI {
  color: #5e6ff9;
}
.SignUp_signup-heading__88aBl {
  font-weight: lighter !important;
}
.SignUp_signup-hello__U4xkA {
  font-weight: bolder;
}
.SignUp_signup-stay__uiLO1 {
  font-weight: lighter;
  word-spacing: 0.3rem;
  height: 1rem;
}
.SignUp_country_phone__1wBX9 input {
  border: 1px solid grey !important;
  border-radius: 9px !important;
  height: 45px !important;
  width: 100% !important;
}
.SignUp_react-tel-input__r5Yzl .SignUp_flag-dropdown__RbjRS {
  position: absolute;
  top: 0;
  bottom: 0;
  padding: 0;
  border-radius: 3px 0 0 3px;
}
.SignUp_bottom-image__121z- {
  flex-direction: column;
  border: 0px;
  position: absolute;
  grid-column: 1/-1;
}

.SignUp_checkbox__gGynt {
  grid-column: 1/-1;
  /* margin-top: -3rem; */
}

.SignUp_form__950qj {
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  /* margin-top: 3rem; */
}

.SignUp_signup_container__2Zy26 {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 100vh;
  padding: 30px 0px;
  background-position: center;
  background-size: cover;
}
.SignUp_text_wrapper__sXcJt :not(strong) {
  font-weight: light;
}

.SignUp_modal-footer__qJWhL {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
}

.SignUp_material-symbols-outlined__jDAd- {
  cursor: pointer;
}
.SignUp_my-modal1__So0fj {
  --bs-modal-border-radius: 1.5rem;
}

.SignUp_modal__PlxfP .SignUp_modal-header__cQn-X {
  --bs-modal-header-border-color: white !important;
  --bs-modal-footer-border-color: white !important;
}

element.SignUp_style__BT90q {
  width: 2.5em;
  text-align: center;
}

.SignUp_modal-footer__qJWhL {
  padding: 0%;
}

@media only screen and (max-width: 1040px) {
  input[type="submit"] {
    margin: 0 auto;
  }
  .SignUp_contact-form__XCoFC {
    text-align: left;
    margin-top: auto;
    width: 100%;
  }
  .SignUp_signup_container__2Zy26 {
    height: 100%;
    bottom: 0px;
  }
  .SignUp_bottom_image__IsKY5 {
    position: absolute;
    flex-direction: column;
    height: 100px;
    bottom: 0px;
  }

  .SignUp_contact-flex-container__S3fTq {
    display: grid;
    flex-direction: column;
    align-items: center;
    background-position-y: bottom;
    background-size: 100vh;
    max-width: 100%;
    max-height: 100%;
    margin: 5px;
  }
  .SignUp_input__KWUKB[type="submit"] {
    margin: 0 auto;
    align-items: center;
    flex-direction: column;
  }
  .SignUp_contact-form__XCoFC {
    display: grid;
    flex-direction: column;
    /* row-gap: 5px; */
  }
  .SignUp_check-box__WYq0D {
    align-items: center;
    max-width: -moz-fit-content;
    max-width: fit-content;
  }
  .SignUp_form__950qj {
    flex-direction: column;
    max-width: -moz-fit-content;
    max-width: fit-content;
    gap: 1rem;
  }
  .SignUp_top-arrow__eNB7o {
    max-width: 60px;
    flex-direction: column;
  }
  .SignUp_top-icon__LgsDq {
    flex-direction: column;
    position: absolute;
    max-width: 50px;
    left: 85%;
  }
  .SignUp_contact-left-image__5XC31 img {
    flex-direction: column;
  }
  .SignUp_contact-left-image__5XC31 h3 {
    flex-direction: column;
  }
  .SignUp_contact-left-image__5XC31 h1 {
    flex-direction: column;
  }
  .SignUp_bottom-image__121z- {
    display: grid;
    flex-direction: column;
    /* height: 80px; */
    position: absolute;
  }
}

@media only screen and (max-width: 280px) {
  .SignUp_contact-flex-container__S3fTq {
    margin-left: 30px;
    margin-right: 4px;
    padding-left: 10px;
    padding-right: 2px;
  }
  .SignUp_bottom-image__121z- {
    height: 5px;
  }
  .SignUp_contact-left-image__5XC31 h3 {
    flex-direction: column;
  }
}

@media only screen and (max-width: 1280px) {
  .SignUp_SignUp_bottom_image__IsKY5__foBOX {
    position: absolute;
    bottom: -60px !important;
    height: 180px;
  }
  .SignUp_Button__yFYmB {
    width: 180px;
    justify-content: flex-end;
    display: grid;
    margin-top: -2rem;
  }
}

@media only screen and (max-width: 760px) {
  .SignUp_contact-left-image__5XC31 img {
    width: 15rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/signup/SignUp.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,OAAO;EACP,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;;EAET;;KAEG;AACL;;;;AAIA;EACE,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;;;;;;;uCAOuC;;AAEvC;;;;;;;GAOG;AACH;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,uDAAuD;EACvD,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;;;EAGE,aAAa;AACf;AACA;;;EAGE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uDAAuD;EACvD,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iDAAiD;EACjD,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;;EAEf,4CAA4C;AAC9C;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;;IAEI;;AAEJ;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2DAA2D;EAC3D,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yDAA8C;EAC9C,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,gDAAgD;EAChD,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,cAAc;IACd,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,2BAAsB;IAAtB,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,2BAAsB;IAAtB,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,SAAS;EACX;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,wBAAwB;IACxB,aAAa;EACf;EAGA;IACE,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,iBAAiB;EACnB;AAPF;;AAUA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n}\n.contact-flex-container {\n  padding-top: 3px;\n  padding-bottom: 10px;\n  display: flex;\n  max-width: 100%;\n  padding: 1rem 2rem;\n  justify-content: space-around;\n  align-items: center;\n  gap: 1%;\n  background-repeat: repeat;\n  background-size: cover;\n  flex-direction: row;\n  height: auto;\n  background-position: center;\n  margin-top: 2rem;\n}\n\n.top-icon {\n  background-position: 25% 75%;\n  position: absolute;\n  z-index: 1;\n  left: 38%;\n  max-width: 7rem;\n  padding-top: 2%;\n}\n\n.large-heading-1 {\n  font-weight: 900;\n}\n\n.top-arrow {\n  max-width: 7rem;\n  background-position: 25% 75%;\n  position: absolute;\n  z-index: 1;\n  margin-left: 2%;\n}\n.contact-left-image img {\n  max-width: 11rem;\n  height: auto;\n  font-family: \"Poppins\", sans-serif;\n  margin-top: 20%;\n  margin-bottom: 1rem;\n}\n.contact-form {\n  margin-top: 40px;\n  font-family: \"Poppins\", sans-serif;\n}\n.checkbox {\n  grid-column: 1/-1;\n}\n\n.special_button {\n  position: absolute;\n  left: 100%;\n}\n\n.bottom_image {\n  position: fixed;\n  height: 8rem;\n  bottom: 0;\n\n  /* @media screen and (max-width: 1800px) and (min-width: 1036px) {\n    bottom: none;\n  } */\n}\n\n\n\n.sticky-button.enabled {\n  opacity: 1;\n  cursor: pointer;\n  background-color: black;\n}\n\n.input-field:focus {\n  color: black;\n}\n\n.input-type {\n  font-size: large;\n  word-spacing: 3px;\n  font-family: \"Poppins\", sans-serif;\n}\n\n/* .loader {\n  border: 16px solid #f3f3f3;\n  border-top: 16px solid rgb(71, 122, 246);\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  margin: 25px;\n  animation: spin 5s linear infinite; */\n\n/* @keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n} */\n.text-center {\n  font-family: \"Poppins\", sans-serif;\n}\n\n.input-field {\n  width: 100%;\n  padding: 11px 18px;\n  font-size: 14px;\n  position: relative;\n  border: none;\n  background-color: inherit;\n  /* box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; */\n  border-radius: 9px;\n  border: 1px solid grey;\n  cursor: pointer;\n  font-family: \"Poppins\", sans-serif;\n}\n.input-field:focus {\n  border-bottom-color: black;\n  font-family: \"Poppins\", sans-serif;\n}\n.input-otp:focus {\n  border-bottom-color: black;\n}\n.label {\n  display: block;\n  margin-bottom: 0.5rem;\n}\nselect {\n  color: black;\n}\noption {\n  color: black;\n}\n\ninput:focus,\ntextarea:focus,\nselect:focus {\n  outline: none;\n}\n.input-field::placeholder .input-field,\n.contact-form,\n.contact-form p {\n  color: black;\n}\n.input-field::placeholder {\n  color: grey;\n}\n.form-control {\n  display: grid;\n  align-items: center;\n  justify-content: center;\n  grid-template-columns: repeat(auto-fit, minmax(3, 1fr));\n  gap: 1rem;\n  margin-top: 3rem;\n}\n.textarea {\n  position: absolute;\n  grid-column: 1/-1;\n  height: 100%;\n  background-color: inherit;\n  border: none;\n  color: black;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n  border-radius: 50px;\n  padding: 8px;\n  cursor: pointer;\n}\n.custom-shape-divider-bottom-1666093673 {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  line-height: 0;\n}\n\n.custom-shape-divider-bottom-1666093673 svg {\n  position: relative;\n  display: block;\n  width: calc(100% + 1.3px);\n  height: 150px;\n}\n\n.custom-shape-divider-bottom-1666093673 .shape-fill {\n  fill: #ffffff;\n}\ninput[type=\"submit\"] {\n  color: white;\n  background-color: #477AF6;\n  font-size: 14px;\n  padding: 11px;\n  letter-spacing: 0.09em;\n  border: none;\n  border-radius: 2px;\n  font-weight: 500;\n}\n\ninput[type=\"submit\"]:hover {\n  cursor: pointer;\n\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n}\n.phone-input {\n  font-size: 12px;\n  border: 1px solid #5e6ff9;\n  border-radius: 28px;\n  width: 100%;\n  outline: none;\n}\n.react-tel-input .form-control {\n  width: inherit;\n  background-color: inherit;\n  font-size: 14px;\n  padding: 14px 14px 10px 60px;\n  color: black;\n  border: none;\n  border-radius: 9px;\n  width: 100%;\n  border: 1px solid grey;\n}\n.react-tel-input .form-control:focus {\n  background-color: inherit;\n  box-shadow: none;\n}\n.contact-form #dropdown {\n  padding: 14px;\n  margin-top: 2%;\n}\n/* .modal-pointer:focus-visible{\n  background-color: rgb(71, 122, 246);\n}  */\n\n.input-otp :hover::after {\n  background-color: rgb(71, 122, 246);\n}\n\n.modal-body > h2 > div {\n  justify-content: center;\n}\n.btn-link:focus {\n  background-color: none !important;\n}\n#get-in-touch {\n  color: #5e6ff9;\n}\n.signup-heading {\n  font-weight: lighter !important;\n}\n.signup-hello {\n  font-weight: bolder;\n}\n.signup-stay {\n  font-weight: lighter;\n  word-spacing: 0.3rem;\n  height: 1rem;\n}\n.country_phone input {\n  border: 1px solid grey !important;\n  border-radius: 9px !important;\n  height: 45px !important;\n  width: 100% !important;\n}\n.react-tel-input .flag-dropdown {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  padding: 0;\n  border-radius: 3px 0 0 3px;\n}\n.bottom-image {\n  flex-direction: column;\n  border: 0px;\n  position: absolute;\n  grid-column: 1/-1;\n}\n\n.checkbox {\n  grid-column: 1/-1;\n  /* margin-top: -3rem; */\n}\n\n.form {\n  display: grid;\n  align-items: center;\n  justify-content: center;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  /* margin-top: 3rem; */\n}\n\n.signup_container {\n  position: relative;\n  background-image: url(\"../../assets//bg4.png\");\n  height: 100vh;\n  padding: 30px 0px;\n  background-position: center;\n  background-size: cover;\n}\n.text_wrapper :not(strong) {\n  font-weight: light;\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n}\n\n.material-symbols-outlined {\n  cursor: pointer;\n}\n.my-modal1 {\n  --bs-modal-border-radius: 1.5rem;\n}\n\n.modal .modal-header {\n  --bs-modal-header-border-color: white !important;\n  --bs-modal-footer-border-color: white !important;\n}\n\nelement.style {\n  width: 2.5em;\n  text-align: center;\n}\n\n.modal-footer {\n  padding: 0%;\n}\n\n@media only screen and (max-width: 1040px) {\n  input[type=\"submit\"] {\n    margin: 0 auto;\n  }\n  .contact-form {\n    text-align: left;\n    margin-top: auto;\n    width: 100%;\n  }\n  .signup_container {\n    height: 100%;\n    bottom: 0px;\n  }\n  .bottom_image {\n    position: absolute;\n    flex-direction: column;\n    height: 100px;\n    bottom: 0px;\n  }\n\n  .contact-flex-container {\n    display: grid;\n    flex-direction: column;\n    align-items: center;\n    background-position-y: bottom;\n    background-size: 100vh;\n    max-width: 100%;\n    max-height: 100%;\n    margin: 5px;\n  }\n  .input[type=\"submit\"] {\n    margin: 0 auto;\n    align-items: center;\n    flex-direction: column;\n  }\n  .contact-form {\n    display: grid;\n    flex-direction: column;\n    /* row-gap: 5px; */\n  }\n  .check-box {\n    align-items: center;\n    max-width: fit-content;\n  }\n  .form {\n    flex-direction: column;\n    max-width: fit-content;\n    gap: 1rem;\n  }\n  .top-arrow {\n    max-width: 60px;\n    flex-direction: column;\n  }\n  .top-icon {\n    flex-direction: column;\n    position: absolute;\n    max-width: 50px;\n    left: 85%;\n  }\n  .contact-left-image img {\n    flex-direction: column;\n  }\n  .contact-left-image h3 {\n    flex-direction: column;\n  }\n  .contact-left-image h1 {\n    flex-direction: column;\n  }\n  .bottom-image {\n    display: grid;\n    flex-direction: column;\n    /* height: 80px; */\n    position: absolute;\n  }\n}\n\n@media only screen and (max-width: 280px) {\n  .contact-flex-container {\n    margin-left: 30px;\n    margin-right: 4px;\n    padding-left: 10px;\n    padding-right: 2px;\n  }\n  .bottom-image {\n    height: 5px;\n  }\n  .contact-left-image h3 {\n    flex-direction: column;\n  }\n}\n\n@media only screen and (max-width: 1280px) {\n  .SignUp_bottom_image__IsKY5 {\n    position: absolute;\n    bottom: -60px !important;\n    height: 180px;\n  }\n}\n@media only screen and (max-width: 1280px) {\n  .Button {\n    width: 180px;\n    justify-content: flex-end;\n    display: grid;\n    margin-top: -2rem;\n  }\n}\n\n@media only screen and (max-width: 760px) {\n  .contact-left-image img {\n    width: 15rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contact-flex-container": `SignUp_contact-flex-container__S3fTq`,
	"top-icon": `SignUp_top-icon__LgsDq`,
	"large-heading-1": `SignUp_large-heading-1__2AZD+`,
	"top-arrow": `SignUp_top-arrow__eNB7o`,
	"contact-left-image": `SignUp_contact-left-image__5XC31`,
	"contact-form": `SignUp_contact-form__XCoFC`,
	"checkbox": `SignUp_checkbox__gGynt`,
	"special_button": `SignUp_special_button__axfZu`,
	"bottom_image": `SignUp_bottom_image__IsKY5`,
	"sticky-button": `SignUp_sticky-button__ReuKQ`,
	"enabled": `SignUp_enabled__sAyUn`,
	"input-field": `SignUp_input-field__n9LuY`,
	"input-type": `SignUp_input-type__buu+c`,
	"text-center": `SignUp_text-center__CUJeG`,
	"input-otp": `SignUp_input-otp__yHHiJ`,
	"label": `SignUp_label__fsVsI`,
	"form-control": `SignUp_form-control__vATZ0`,
	"textarea": `SignUp_textarea__Jvseu`,
	"custom-shape-divider-bottom-1666093673": `SignUp_custom-shape-divider-bottom-1666093673__FPYrm`,
	"shape-fill": `SignUp_shape-fill__f107c`,
	"phone-input": `SignUp_phone-input__O1kKN`,
	"react-tel-input": `SignUp_react-tel-input__r5Yzl`,
	"dropdown": `SignUp_dropdown__VunzG`,
	"modal-body": `SignUp_modal-body__iJ9IN`,
	"btn-link": `SignUp_btn-link__ivTUi`,
	"get-in-touch": `SignUp_get-in-touch__6JsmI`,
	"signup-heading": `SignUp_signup-heading__88aBl`,
	"signup-hello": `SignUp_signup-hello__U4xkA`,
	"signup-stay": `SignUp_signup-stay__uiLO1`,
	"country_phone": `SignUp_country_phone__1wBX9`,
	"flag-dropdown": `SignUp_flag-dropdown__RbjRS`,
	"bottom-image": `SignUp_bottom-image__121z-`,
	"form": `SignUp_form__950qj`,
	"signup_container": `SignUp_signup_container__2Zy26`,
	"text_wrapper": `SignUp_text_wrapper__sXcJt`,
	"modal-footer": `SignUp_modal-footer__qJWhL`,
	"material-symbols-outlined": `SignUp_material-symbols-outlined__jDAd-`,
	"my-modal1": `SignUp_my-modal1__So0fj`,
	"modal": `SignUp_modal__PlxfP`,
	"modal-header": `SignUp_modal-header__cQn-X`,
	"style": `SignUp_style__BT90q`,
	"input": `SignUp_input__KWUKB`,
	"check-box": `SignUp_check-box__WYq0D`,
	"SignUp_bottom_image__IsKY5": `SignUp_SignUp_bottom_image__IsKY5__foBOX`,
	"Button": `SignUp_Button__yFYmB`
};
export default ___CSS_LOADER_EXPORT___;
